<template>
	<az-container class="mb-1 ml-0 pa-6" fluid>
		<h3 class="color-titulo font-weight-bold title mt-0 mb-5">Dados do Aderente</h3>
		<v-form ref="form" v-model="formIsValid" @submit.prevent="enviarInformacoesSolicitante">
			<v-row class="dados-solicitante">
				<v-col cols="12" sm="12" lg="8" md="8">
					<label-personalizado
						nome-campo="Nome Completo"
						:class="[corTitulo, 'label']"
						:obrigatorio-por-padrao="true"
					>
					</label-personalizado>
					<v-text-field
						class="text pt-0"
						ref="nomeCompletoInput"
						v-model.trim="nomeCompleto"
						maxlength="80"
						:rules="nomeRule"
						@focus="isFocused('nome')"
						@blur="isBlured('nome')"
					>
					</v-text-field>
				</v-col>
				<v-col cols="12" sm="12" md="4">
					<label-personalizado
						nome-campo="Órgão/Entidade Pertencente"
						obrigatorio-por-padrao
						:class="[corTitulo, 'label']"
					></label-personalizado>
					<v-text-field
						class="text pt-0"
						ref="nomeOrgaoInput"
						v-model.trim="nomeOrgao"
						:rules="nomeOrgaoEntidadeRule"
						maxlength="64"
						@focus="isFocused('nomeOrgao')"
						@blur="isBlured('nomeOrgao')"
					>
					</v-text-field>
				</v-col>
				<v-col cols="12" sm="6" md="4" lg="4" xl="4">
					<label-personalizado
						nome-campo="CNPJ"
						:class="[corTitulo, 'label']"
						obrigatorio-por-padrao
					></label-personalizado>
					<v-text-field
						class="text pt-0"
						ref="cnpjInput"
						v-model="cnpj"
						@input="cnpj = ($event || '').toUpperCase()"
						:rules="cnpjRule"
						v-mask="cnpjMask"
						maxlength="18"
						@focus="isFocused('cnpj')"
						@blur="isBlured('cnpj')"
					>
					</v-text-field>
				</v-col>
				<v-col cols="12" sm="6" md="4" lg="4" xl="4">
					<label-personalizado
						nome-campo="E-mail"
						:class="[corTitulo, 'label']"
						obrigatorio-por-padrao
					></label-personalizado>
					<v-text-field
						class="text pt-0"
						ref="emailInput"
						v-model.trim="email"
						:rules="emailRule"
						type="email"
						maxlength="64"
						@focus="isFocused('email')"
						@blur="isBlured('email')"
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="6" md="4" lg="4" xl="4">
					<label-personalizado
						nome-campo="Número de Contato"
						:class="[corTitulo, 'label']"
						obrigatorio-por-padrao
					></label-personalizado>
					<v-text-field
						class="text pt-0"
						ref="numeroContatoInput"
						v-model="numeroContato"
						:rules="numeroContatoRule"
						v-mask="telefoneMask"
						maxlength="15"
						@focus="isFocused('numeroContato')"
						@blur="isBlured('numeroContato')"
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="6" md="4">
					<label-personalizado
						nome-campo="Código da Unidade Compradora"
						:class="[corTitulo, 'label']"
						obrigatorio-por-padrao
					></label-personalizado>
					<v-text-field
						class="text pt-0"
						ref="codigoUnidadeCompradoraInput"
						v-model.trim="codigoUnidadeCompradora"
						v-input-mask="mascaraSomenteNumeros"
						:rules="codigoUnidadeCompradoraRule"
						maxlength="30"
						@focus="isFocused('codigoUnidadeCompradora')"
						@blur="isBlured('codigoUnidadeCompradora')"
					></v-text-field>
				</v-col>
			</v-row>
		</v-form>
	</az-container>
</template>

<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import FormUtils from '@/core/utils/FormUtils'
import { actionTypes } from '@/core/constants'
import _ from 'lodash'
import mutationTypes from '@/core/constants/mutation-types'
import { mapState } from 'vuex'
import { Alert } from '@/core/utils'

export default {
	name: 'cadastro-solicitante-view',
	components: { LabelPersonalizado },
	data() {
		return {
			corTitulo: 'grey--text text--darken-2',
			nomeRule: [(value) => FormUtils.validadores.required(value)],
			nomeOrgaoEntidadeRule: [(value) => FormUtils.validadores.required(value)],
			cnpjRule: [(value) => FormUtils.validadores.required(value), (value) => FormUtils.validadores.cnpj(value)],
			emailRule: [
				(value) => FormUtils.validadores.required(value),
				(value) => FormUtils.validadores.email(value),
			],
			numeroContatoRule: [
				(value) => FormUtils.validadores.required(value),
				(value) => FormUtils.validadores.telefone(value),
			],
			codigoUnidadeCompradoraRule: [(value) => FormUtils.validadores.required(value)],
			mascaraSomenteNumeros: { regex: '\\d{0,30}' },
			formIsValid: this.$store.state.adesaoPublica.formIsValid,
			idSolicitacaoAdesao: this.$store.state.adesaoPublica.idSolicitacaoAdesao,
			estadoAnteriorForm: this.$store.state.adesaoPublica.estadoAnteriorForm,
			campoFocado: null,
			nomeCompleto: '',
			nomeOrgao: '',
			cnpj: '',
			email: '',
			numeroContato: '',
			codigoUnidadeCompradora: '',
			informacoesSolicitanteFoiBuscado: false,
			alert: new Alert(this.$store),
		}
	},
	computed: {
		telefoneMask() {
			return FormUtils.mascaras.telefone(this.numeroContato)
		},
		cnpjMask() {
			return FormUtils.mascaras.cnpj(this.cnpj)
		},
		...mapState({
			idAta: (state) => state.adesaoPublica.filtro.idAta,
		}),
	},
	watch: {
		formIsValid(isValido) {
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_FORM_IS_VALID, isValido)
		},
		idSolicitacaoAdesao(id) {
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_ID_SOLICITACAO_ADESAO, id)
		},
		estadoAnteriorForm(form) {
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_ESTADO_FORM, form)
		},
	},
	methods: {
		isFocused(campo) {
			this.campoFocado = campo
		},
		isBlured(campo) {
			if (this.campoFocado !== campo) return
			if (this.campoEmailAndCnpjValidos()) this.buscarInformacoesSolicitanteSeJaCadastrado()
			this.campoFocado = null
			this.verificarFormParaEnviar()
		},
		verificarFormParaEnviar() {
			const payload = this.criarPayloadManifestacao()
			if (!this.formIsValid || this.campoFocado || this.formNaoFoiAlterado(payload)) return
			this.enviarInformacoesSolicitante(payload)
		},
		campoEmailAndCnpjValidos() {
			const cnpjValido = this.$refs.cnpjInput.validate()
			const emailValido = this.$refs.emailInput.validate()
			const camposEmailOuCnpjEstavamFocados = this.campoFocado === 'email' || this.campoFocado === 'cnpj'
			return cnpjValido && emailValido && !!camposEmailOuCnpjEstavamFocados
		},
		async enviarInformacoesSolicitante(payload) {
			const { id } = await this.$store.dispatch(
				actionTypes.ADESAO_PUBLICA.SALVAR_INFORMACOES_SOLICITANTE,
				payload,
			)
			this.idSolicitacaoAdesao.value = id
			this.estadoAnteriorForm = { ...payload, id: id }
			await this.carregarItens()
		},
		formNaoFoiAlterado(payload) {
			return _.isEqual(payload, this.estadoAnteriorForm)
		},
		criarPayloadManifestacao() {
			return {
				id: this.idSolicitacaoAdesao.value,
				nomeCompleto: this.nomeCompleto,
				email: this.email,
				documento: FormUtils.removerMascaraInput(this.cnpj),
				nomeOrgao: this.nomeOrgao,
				numeroContato: FormUtils.removerMascaraInput(this.numeroContato),
				codigoUnidadeCompradora: this.codigoUnidadeCompradora,
				idAta: this.idAta.value,
			}
		},
		async buscarInformacoesSolicitanteSeJaCadastrado() {
			if (this.informacoesSolicitanteFoiBuscado) return

			const response = await this.$store.dispatch(actionTypes.ADESAO_PUBLICA.BUSCAR_INFORMACOES_SOLICITANTE, {
				idAta: this.idAta.value,
				email: this.email,
				documento: FormUtils.removerMascaraInput(this.cnpj),
			})

			if (!response) return
			this.alert.showSuccess(`Dados já preenchidos anteriormente!`)
			await this.setarValores(response)
			await this.carregarItens()
			await this.carregarAnexos()
		},
		async setarValores(response) {
			this.informacoesSolicitanteFoiBuscado = true
			this.idSolicitacaoAdesao.value = response.id
			this.nomeCompleto = response.nomeCompleto
			this.nomeOrgao = response.nomeOrgao
			this.numeroContato = FormUtils.aplicarMascaraNumero(response.numeroContato)
			this.codigoUnidadeCompradora = response.codigoUnidadeCompradora || ''
			this.estadoAnteriorForm = this.criarPayloadManifestacao()
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_JUSTIFICATIVA, response.justificativa)
		},
		async carregarItens() {
			const retorno = await this.$store.dispatch(actionTypes.ADESAO_PUBLICA.BUSCAR_ITENS_POR_FILTRO)
			if (!retorno.itens.length) return
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_INFORMACOES_ITENS, retorno)
		},
		async carregarAnexos() {
			const retorno = await this.$store.dispatch(actionTypes.ADESAO_PUBLICA.BUSCAR_ANEXOS_POR_FILTRO)
			if (!retorno.itens.length) return
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_INFORMACOES_ANEXOS, retorno)
		},
	},
}
</script>

<style lang="stylus" scoped>
.show-counter .v-counter {
	display: block !important;
}

.dados-solicitante
	.label
		font-weight bold !important
		font-size 0.75em !important

	.text
		font-size .8em !important
</style>
